import useTranslation from 'Hooks/useTranslation';
import useComponent from './useComponent';
import useComponentCourse from './useComponentCourse';

const useConfig = ({ isByUsers, setEmployee, employees, courses, setCourse, categories }) => {
  const { t2 } = useTranslation('DevelopmentPlan');
  const { thereIsComponent } = useComponent();
  const { thereIsComponentCourses } = useComponentCourse({
    categories,
  });
  if (isByUsers) {
    return {
      titleHighlighted: t2('ByEmployee'),
      title: ['Nombre', 'Departamento', 'Puesto', 'CursosPendientes', 'Progreso'],
      labels: ['fullName', 'department', 'jobTitle', 'pendingCourses', 'progress'],
      headers: [t2('Name'), t2('Department'), t2('JobTitle'), t2('PendingCourses'), t2('Progress'), t2('LastAssess')],
      searchPlaceholder: t2('FindEmployee'),
      setData: setEmployee,
      thereIsComponent,
      tableHeaders: [
        t2('Name'),
        t2('Department'),
        t2('JobTitle'),
        t2('PendingCourses'),
        t2('Progress'),
        t2('LastAssess'),
      ],
      tableInformation: employees,
      tableLimitColumns: 6,
      display: 'flex',
    };
  }
  return {
    titleHighlighted: t2('ByCourses'),
    title: ['Nombre del curso', 'Prioridades', 'Número de empleados', 'Categoría', 'Progreso'],
    labels: ['name', 'priority', 'totalUsers', 'category', 'progress'],
    headersCourse: [t2('CourseName'), t2('Priorities'), t2('NumberOfEmployees'), t2('Category'), t2('Progress')],
    searchPlaceholder: t2('FindCourse'),
    setData: setCourse,
    thereIsComponent: thereIsComponentCourses,
    tableHeaders: [t2('CourseName'), t2('Priorities'), t2('NumberOfEmployees'), t2('Category'), t2('Progress')],
    tableInformation: courses,
    tableLimitColumns: 5,
    display: 'none',
  };
};

export default useConfig;
